import { AntdSelect } from '@/components';
import React, { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ChainSelect } from '../ChainSelect';
import styles from './index.module.scss';
import { useTokenDetail } from './hooks';
import { useDebounceState } from '@/hooks';

const { Option } = AntdSelect;

export const TokenHolder = () => {
  const { control, watch, getValues, setValue } = useFormContext();
  const [chainId] = watch(['data.chain_id']);
  const [debounceTokenId, setTokenId, setNow] = useDebounceState<string>(
    getValues('data.token_id') || '',
  );
  const { data } = useTokenDetail({ chainId, id: debounceTokenId });

  const list = useMemo(() => (data?.token ? [data?.token] : []), [data?.token]);

  const options = useMemo(
    () =>
      list?.map(i => (
        <Option key={i.id} value={i.id} label={i.display_symbol || i.symbol}>
          <div className={styles.tokenOption}>
            <img src={i?.logo_url} alt="" className={styles.logo} />
            <div className={styles.tokenSymbol}>{i.display_symbol || i.symbol}</div>
          </div>
        </Option>
      )),
    [list],
  );

  const emptyContent = useMemo(() => <div className={styles.empty}>No Match</div>, []);

  const handleSearch = useCallback(
    (val: string) => {
      if (!val) {
        setTokenId(getValues('data.token_id'));
      } else {
        setTokenId(val);
      }
    },
    [getValues, setTokenId],
  );

  return (
    <div className={styles.holderSelectContainer}>
      <Controller
        control={control}
        name="data.chain_id"
        render={({ field }) => (
          <ChainSelect
            value={field.value}
            onChange={val => {
              field.onChange(val.id);
              setNow('');
              setValue('data.token_id', '');
              setValue('data.token_symbol', '');
              setValue('data.logo_url', '');
            }}
          />
        )}
        rules={{
          required: true,
        }}
      />
      <Controller
        control={control}
        name="data.token_id"
        render={({ field }) => {
          return (
            <AntdSelect
              className={styles.tokenSelect}
              placeholder="Paste token contract address"
              value={!data ? undefined : field?.value}
              onSelect={val => {
                if (val) {
                  setValue('data.token_symbol', data?.token?.symbol);
                  setValue('data.logo_url', data?.token?.logo_url);
                }
                field?.onChange((val as string)?.toLowerCase());
              }}
              onSearch={handleSearch}
              showArrow={false}
              notFoundContent={emptyContent}
              showSearch
              disabled={!chainId}>
              {options}
            </AntdSelect>
          );
        }}
        rules={{
          required: true,
        }}
      />
    </div>
  );
};
